const decodeJwtPayload = (token: string): string | null => {
  const payload = token.split('.')[1];
  if (!payload) {
    return null;
  }

  const normalized = payload
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '=');

  try {
    if (typeof window !== 'undefined' && typeof window.atob === 'function') {
      return decodeURIComponent(
        window.atob(normalized)
          .split('')
          .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
          .join(''),
      );
    }

    return Buffer.from(normalized, 'base64').toString('utf8');
  } catch {
    return null;
  }
};

export const isJwtExpired = (token: string): boolean => {
  const decodedPayload = decodeJwtPayload(token);
  if (!decodedPayload) {
    return true;
  }

  try {
    const payload = JSON.parse(decodedPayload);
    const exp = Number(payload?.exp);
    if (Number.isNaN(exp)) {
      return false;
    }

    return exp < Math.floor(Date.now() / 1000);
  } catch {
    return true;
  }
};
